import type {
	PeadTypeSelectItem,
	QtrSelectItem,
} from "@/components/widgets/Pead/types";

export const QTR_ITEMS: QtrSelectItem[] = [
	{ id: 0, value: "20 Qtr", label: "20 Qtr" },
	{ id: 1, value: "40 Qtr", label: "40 Qtr" },
];

export const PEAD_FILTER_ITEMS: PeadTypeSelectItem[] = [
	{ id: 0, value: "PEAD", label: "PEAD" },
	{ id: 1, value: "Seasonal", label: "Seasonal" },
];
